<template>
  <div class="row">
    <div class="col-lg-6 col-sm-12 col-xs-12" v-for="input in inputs" :key="input.key">
      <Input v-model="projectDataLocal.maschine[input.key]" :placeholder="input.name" :viewMode="!canEdit" />
    </div>
  </div>
</template>

<script>
import Input from '../../../../common/input';

export default {
  title: 'Maschine',
  components: {
    Input,
  },
  props: {
    projectData: {
      type: Object,
      default: () => {},
    },
    canEdit: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      inputs: [
        {
          name: 'Machine number',
          key: 'maschineNumber',
        },
        {
          name: 'Manufacturer',
          key: 'manufacturer',
        },
        {
          name: 'Machine type',
          key: 'maschineType',
        },
        {
          name: 'Machine category',
          key: 'maschineCategory',
        },
        {
          name: 'Manufacturing order number',
          key: 'manufacturingOrderNumber',
        },
      ],
    };
  },
  computed: {
    projectDataLocal: {
      get: function () {
        return this.projectData;
      },
      set: function (value) {
        this.$emit('projectData', value);
      },
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss"></style>
